import React, { useEffect } from 'react';
import { useControleDemanda } from '../context/ControleDemandaProvider';
import DashboardEstatisticas from './DashboardEstatisticas';
import '../styles.css';

export default function DashboardDemandas() {
  const { carregarDadosAuxiliares, carregarSetores } = useControleDemanda();

  useEffect(() => {
    carregarDadosAuxiliares();
    carregarSetores();
  }, [carregarDadosAuxiliares, carregarSetores]);

  return (
    <div className="dashboard-demandas">
      <DashboardEstatisticas />
    </div>
  );
}